module.exports = __webpack_public_path__ + "static/img/produce12.f8f5824.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce12.png
// module id = 142
// module chunks = 4